// extracted by mini-css-extract-plugin
export var indeterminate = "_4g-6";
export var md = "_4g-5";
export var semantic = "_4g-7";
export var sm = "_4g-4";
export var text = "_4g-8";
export var toggleControl = "_4g-0";
export var toggleInput = "_4g-1";
export var toggleSwitch = "_4g-2";
export var xs = "_4g-3";